import React, { useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Modal  from "@react/shared/ui/Modal"
import Button from "@react/shared/ui/Button"
import { patchRequest, pathname } from "@react/helpers/fetch"

// Link (or unlink) this quote to one of its client's open (pipeline) opportunities.
const LinkOpportunityModal = ({ isOpen, onClose, linkUrl, unlinkUrl, linked, opportunities = [] }) => {
  const [selected, setSelected] = useState(linked?.id || opportunities[0]?.id || null)
  const [busy, setBusy] = useState(false)

  const link = () => {
    if (!selected || busy) return
    setBusy(true)
    patchRequest({ url: pathname({ path: linkUrl, params: { opportunity_id: selected } }) })
      .then(res => {
        if (res?.ok) { window.location.reload() }
        else { flashAlert(I18n.t("quotes.builder.footer.unknown_error")); setBusy(false) }
      })
      .catch(() => { flashAlert(I18n.t("quotes.builder.footer.network_error")); setBusy(false) })
  }

  const unlink = () => {
    if (busy) return
    setBusy(true)
    patchRequest({ url: unlinkUrl })
      .then(res => {
        if (res?.ok) { window.location.reload() }
        else { flashAlert(I18n.t("quotes.builder.footer.unknown_error")); setBusy(false) }
      })
      .catch(() => { flashAlert(I18n.t("quotes.builder.footer.network_error")); setBusy(false) })
  }

  return (
    <Modal
      isOpen  = {isOpen}
      onClose = {onClose}
      size    = "md"
      eyebrow = "CRM"
      title   = {linked ? "Opportunité" : "Lier à une opportunité"}
      footer  = {
        <>
          <Button variant="ghost" onClick={onClose}>Fermer</Button>
          {linked ? (
            <Button variant="danger-ghost" onClick={unlink} disabled={busy}>
              <FontAwesomeIcon icon={busy ? "spinner" : "link-slash"} spin={busy} /> Délier
            </Button>
          ) : (
            <Button variant="primary" onClick={link} disabled={!selected || busy}>
              <FontAwesomeIcon icon={busy ? "spinner" : "link"} spin={busy} /> Lier
            </Button>
          )}
        </>
      }
    >
      {linked ? (
        <p className="text-[13px] text-slate-700">
          Ce devis est lié à l'opportunité{" "}
          <a href={`/crm/opportunities/${linked.id}`} className="font-semibold text-blue-600 hover:text-blue-700 hover:underline">
            {linked.title}
          </a>.
        </p>
      ) : opportunities.length === 0 ? (
        <p className="text-[13px] text-slate-500">Aucune opportunité ouverte pour ce client.</p>
      ) : (
        <div className="space-y-1.5">
          {opportunities.map(o => (
            <label
              key       = {o.id}
              className = {`flex items-center gap-3 px-3 py-2.5 rounded-lg border cursor-pointer transition ${
                String(selected) === String(o.id) ? "border-blue-300 bg-blue-50" : "border-slate-200 hover:bg-slate-50"
              }`}
            >
              <input
                type     = "radio"
                name     = "opportunity"
                checked  = {String(selected) === String(o.id)}
                onChange = {() => setSelected(o.id)}
              />
              <span className="text-[13.5px] text-slate-800">{o.title}</span>
            </label>
          ))}
        </div>
      )}
    </Modal>
  )
}

export default LinkOpportunityModal
